import { render, staticRenderFns } from "./MasterApplyControlH5.vue?vue&type=template&id=b4f60f9a&scoped=true"
import script from "./MasterApplyControlH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./MasterApplyControlH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MasterApplyControlH5.vue?vue&type=style&index=0&id=b4f60f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f60f9a",
  null
  
)

export default component.exports